<template>
  <b-form v-if="user" id="personalData" :autocomplete=autoComplete>

    <div v-if="!admin">
      <b-form-group label-for="gender" label="Gravatar" label-cols=12 label-cols-md=5 label-cols-lg=6 label-cols-xl=4 label-align-md="right">
        <a href="https://de.gravatar.com/" target="_blank">
          <gravatar :user=user></gravatar>
        </a>
      </b-form-group>
    </div>

    <b-form-group label-for="gender" label="Anrede" label-cols=12 label-cols-md=5 label-cols-lg=6 label-cols-xl=4 label-align-md="right">
      <b-form-invalid-feedback>Bitte wählen Sie eine Andrede</b-form-invalid-feedback>
      <form-option-gender :gender=user.gender></form-option-gender>
    </b-form-group>

    <b-form-group label-for="firstname" label="Vorname" label-cols=12 label-cols-md=5 label-cols-lg=6 label-cols-xl=4 label-align-md="right">
      <b-form-input type="text" id="firstname" v-model="user.firstname" autocomplete="given-name"/>
      <b-form-invalid-feedback>Bitte tragen Sie Ihren Vornamen ein</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label-for="lastname" label="Nachname" label-cols=12 label-cols-md=5 label-cols-lg=6 label-cols-xl=4 label-align-md="right">
      <b-form-input type="text" id="lastname" v-model="user.lastname" autocomplete="family-name"/>
      <b-form-invalid-feedback>Bitte tragen Sie ihren Nachnamen ein</b-form-invalid-feedback>
    </b-form-group>

    <div v-if="admin">
      <b-form-group label-for="email" label="E-Mail" label-cols=12 label-cols-md=5 label-cols-lg=6 label-cols-xl=4 label-align-md="right">
        <b-form-input type="text" id="email" v-model="user.email"/>
      </b-form-group>

      <b-form-group label-for="emailVerified" label="E-Mail bestätigt" label-cols=12 label-cols-md=5 label-cols-lg=6 label-cols-xl=4 label-align-md="right">
        <b-form-select id="emailVerified" v-model="user.emailVerified" :options="{true : 'Ja', false: 'Nein'}"/>
      </b-form-group>
    </div>

    <b-button type="button" v-on:click="save" variant="primary" class="float-right">Daten speichern</b-button>

  </b-form>
</template>
<script>
import Gravatar from '@/components/user/Gravatar'
import FormOptionGender from '@/components/misc/FormOptionGender'

export default {
  name: 'UserData',
  props: ['user', 'autocomplete', 'admin'],
  components: {
    gravatar: Gravatar,
    formOptionGender: FormOptionGender
  },
  computed: {
    autoComplete: function () {
      return this.autocomplete === false ? 'off' : 'on'
    }
  },
  methods: {
    save: function () {
      let body = {
        firstname: this.user.firstname,
        lastname: this.user.lastname,
        gender: this.user.gender
      }

      if (this.admin) {
        body.email = this.user.email
        body.emailVerified = (this.user.emailVerified === 'true')
      }

      this.axios.patch('/users/' + this.user.id, JSON.stringify(body))
        .then(() => {
          this.$eventHub.$emit('info', 'Daten erfolgreich gespeichert')
        })

        .catch((err) => {
          this.$eventHub.$emit('error', err)
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/user/Form.vue